// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: entry/payload/EntryAdminPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { PagingRequestPayload, PagingResponsePayload } from "../../common/model/PagingPt";
import { WeightClassPayload } from "../../fight/model/FightPt";
import { TournamentPayload } from "../../tournament/model/TournamentPt";
import {
  EntryPayload,
  EntryPlayerStatusPayload,
  entryPlayerStatusPayloadFromJSON,
  entryPlayerStatusPayloadToJSON,
  EntrySearchConditionPayload,
  EntrySummaryPayload,
} from "../model/EntryPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.entry.payload";

export interface EntryAdminGetByPagingRequestPayload {
  /** paging */
  paging:
    | PagingRequestPayload
    | undefined;
  /** 검색 조건 */
  search: EntrySearchConditionPayload | undefined;
}

export interface EntryAdminGetByPagingResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 */
  data: EntrySummaryPayload[];
  /** paging */
  paging: PagingResponsePayload | undefined;
}

/** 관리자 상세 조회 (연락처 · 비밀번호 확인 없이 신청 id 로 본다) */
export interface EntryAdminGetByIdRequestPayload {
  /** 신청 고유 id */
  id: string;
}

export interface EntryAdminGetByIdResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 */
  data:
    | EntryPayload
    | undefined;
  /** 신청이 속한 대회 */
  tournament: TournamentPayload | undefined;
}

/**
 * 체급 확정
 *
 * 신청 · 수정에서는 체급을 무시하므로 이 API 가 WEIGHT_CLASS 를 채우는 유일한 경로다.
 * 종목과 체급이 어긋나면 거부한다 (체급 코드는 종목 안에서만 유일하다).
 */
export interface EntryClassifyWeightClassRequestPayload {
  /** 선수 고유 id */
  playerId: string;
  /** 확정할 체급 (sport + oneof 만 신뢰한다) */
  weightClass: WeightClassPayload | undefined;
}

/** 체급 후보 조회 (운영자가 고를 목록. 체중 · 부 · 성별로 좁힌 결과다) */
export interface EntryGetWeightClassCandidateRequestPayload {
  /** 선수 고유 id */
  playerId: string;
}

export interface EntryGetWeightClassCandidateResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 체중 · 부 · 성별로 좁힌 후보 (0개면 운영자가 직접 골라야 한다) */
  candidate: WeightClassPayload[];
  /** 그 종목의 전체 체급 (후보가 0개일 때 운영자가 고를 목록) */
  allOfSport: WeightClassPayload[];
}

/**
 * 선수 상태 전이 (승인 · 반려)
 *
 * 반려로 보낼 때는 사유가 필수다.
 */
export interface EntryUpdatePlayerStatusRequestPayload {
  /** 선수 고유 id */
  playerId: string;
  /** 바꿀 상태 */
  status: EntryPlayerStatusPayload;
  /** 반려 사유 (반려일 때만 쓴다) */
  rejectedReason: string;
}

/** 신청 비밀번호 초기화 (체육관이 분실했을 때 관리자가 임시 비밀번호를 발급한다) */
export interface EntryResetPasswordRequestPayload {
  /** 신청 고유 id */
  id: string;
}

export interface EntryResetPasswordResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 발급된 임시 비밀번호 (이 응답에만 담기고 저장은 해시로만 한다) */
  temporaryPassword: string;
}

function createBaseEntryAdminGetByPagingRequestPayload(): EntryAdminGetByPagingRequestPayload {
  return { paging: undefined, search: undefined };
}

export const EntryAdminGetByPagingRequestPayload: MessageFns<EntryAdminGetByPagingRequestPayload> = {
  encode(message: EntryAdminGetByPagingRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.paging !== undefined) {
      PagingRequestPayload.encode(message.paging, writer.uint32(10).fork()).join();
    }
    if (message.search !== undefined) {
      EntrySearchConditionPayload.encode(message.search, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryAdminGetByPagingRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryAdminGetByPagingRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.paging = PagingRequestPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.search = EntrySearchConditionPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryAdminGetByPagingRequestPayload {
    return {
      paging: isSet(object.paging) ? PagingRequestPayload.fromJSON(object.paging) : undefined,
      search: isSet(object.search) ? EntrySearchConditionPayload.fromJSON(object.search) : undefined,
    };
  },

  toJSON(message: EntryAdminGetByPagingRequestPayload): unknown {
    const obj: any = {};
    if (message.paging !== undefined) {
      obj.paging = PagingRequestPayload.toJSON(message.paging);
    }
    if (message.search !== undefined) {
      obj.search = EntrySearchConditionPayload.toJSON(message.search);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryAdminGetByPagingRequestPayload>, I>>(
    base?: I,
  ): EntryAdminGetByPagingRequestPayload {
    return EntryAdminGetByPagingRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryAdminGetByPagingRequestPayload>, I>>(
    object: I,
  ): EntryAdminGetByPagingRequestPayload {
    const message = createBaseEntryAdminGetByPagingRequestPayload();
    message.paging = (object.paging !== undefined && object.paging !== null)
      ? PagingRequestPayload.fromPartial(object.paging)
      : undefined;
    message.search = (object.search !== undefined && object.search !== null)
      ? EntrySearchConditionPayload.fromPartial(object.search)
      : undefined;
    return message;
  },
};

function createBaseEntryAdminGetByPagingResponsePayload(): EntryAdminGetByPagingResponsePayload {
  return { result: undefined, data: [], paging: undefined };
}

export const EntryAdminGetByPagingResponsePayload: MessageFns<EntryAdminGetByPagingResponsePayload> = {
  encode(message: EntryAdminGetByPagingResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      EntrySummaryPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.paging !== undefined) {
      PagingResponsePayload.encode(message.paging, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryAdminGetByPagingResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryAdminGetByPagingResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(EntrySummaryPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.paging = PagingResponsePayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryAdminGetByPagingResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data) ? object.data.map((e: any) => EntrySummaryPayload.fromJSON(e)) : [],
      paging: isSet(object.paging) ? PagingResponsePayload.fromJSON(object.paging) : undefined,
    };
  },

  toJSON(message: EntryAdminGetByPagingResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => EntrySummaryPayload.toJSON(e));
    }
    if (message.paging !== undefined) {
      obj.paging = PagingResponsePayload.toJSON(message.paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryAdminGetByPagingResponsePayload>, I>>(
    base?: I,
  ): EntryAdminGetByPagingResponsePayload {
    return EntryAdminGetByPagingResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryAdminGetByPagingResponsePayload>, I>>(
    object: I,
  ): EntryAdminGetByPagingResponsePayload {
    const message = createBaseEntryAdminGetByPagingResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => EntrySummaryPayload.fromPartial(e)) || [];
    message.paging = (object.paging !== undefined && object.paging !== null)
      ? PagingResponsePayload.fromPartial(object.paging)
      : undefined;
    return message;
  },
};

function createBaseEntryAdminGetByIdRequestPayload(): EntryAdminGetByIdRequestPayload {
  return { id: "" };
}

export const EntryAdminGetByIdRequestPayload: MessageFns<EntryAdminGetByIdRequestPayload> = {
  encode(message: EntryAdminGetByIdRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryAdminGetByIdRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryAdminGetByIdRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryAdminGetByIdRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: EntryAdminGetByIdRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryAdminGetByIdRequestPayload>, I>>(base?: I): EntryAdminGetByIdRequestPayload {
    return EntryAdminGetByIdRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryAdminGetByIdRequestPayload>, I>>(
    object: I,
  ): EntryAdminGetByIdRequestPayload {
    const message = createBaseEntryAdminGetByIdRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseEntryAdminGetByIdResponsePayload(): EntryAdminGetByIdResponsePayload {
  return { result: undefined, data: undefined, tournament: undefined };
}

export const EntryAdminGetByIdResponsePayload: MessageFns<EntryAdminGetByIdResponsePayload> = {
  encode(message: EntryAdminGetByIdResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      EntryPayload.encode(message.data, writer.uint32(18).fork()).join();
    }
    if (message.tournament !== undefined) {
      TournamentPayload.encode(message.tournament, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryAdminGetByIdResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryAdminGetByIdResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = EntryPayload.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tournament = TournamentPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryAdminGetByIdResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: isSet(object.data) ? EntryPayload.fromJSON(object.data) : undefined,
      tournament: isSet(object.tournament) ? TournamentPayload.fromJSON(object.tournament) : undefined,
    };
  },

  toJSON(message: EntryAdminGetByIdResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data !== undefined) {
      obj.data = EntryPayload.toJSON(message.data);
    }
    if (message.tournament !== undefined) {
      obj.tournament = TournamentPayload.toJSON(message.tournament);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryAdminGetByIdResponsePayload>, I>>(
    base?: I,
  ): EntryAdminGetByIdResponsePayload {
    return EntryAdminGetByIdResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryAdminGetByIdResponsePayload>, I>>(
    object: I,
  ): EntryAdminGetByIdResponsePayload {
    const message = createBaseEntryAdminGetByIdResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? EntryPayload.fromPartial(object.data)
      : undefined;
    message.tournament = (object.tournament !== undefined && object.tournament !== null)
      ? TournamentPayload.fromPartial(object.tournament)
      : undefined;
    return message;
  },
};

function createBaseEntryClassifyWeightClassRequestPayload(): EntryClassifyWeightClassRequestPayload {
  return { playerId: "", weightClass: undefined };
}

export const EntryClassifyWeightClassRequestPayload: MessageFns<EntryClassifyWeightClassRequestPayload> = {
  encode(message: EntryClassifyWeightClassRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.playerId !== "") {
      writer.uint32(10).string(message.playerId);
    }
    if (message.weightClass !== undefined) {
      WeightClassPayload.encode(message.weightClass, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryClassifyWeightClassRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryClassifyWeightClassRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.playerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.weightClass = WeightClassPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryClassifyWeightClassRequestPayload {
    return {
      playerId: isSet(object.playerId) ? globalThis.String(object.playerId) : "",
      weightClass: isSet(object.weightClass) ? WeightClassPayload.fromJSON(object.weightClass) : undefined,
    };
  },

  toJSON(message: EntryClassifyWeightClassRequestPayload): unknown {
    const obj: any = {};
    if (message.playerId !== "") {
      obj.playerId = message.playerId;
    }
    if (message.weightClass !== undefined) {
      obj.weightClass = WeightClassPayload.toJSON(message.weightClass);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryClassifyWeightClassRequestPayload>, I>>(
    base?: I,
  ): EntryClassifyWeightClassRequestPayload {
    return EntryClassifyWeightClassRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryClassifyWeightClassRequestPayload>, I>>(
    object: I,
  ): EntryClassifyWeightClassRequestPayload {
    const message = createBaseEntryClassifyWeightClassRequestPayload();
    message.playerId = object.playerId ?? "";
    message.weightClass = (object.weightClass !== undefined && object.weightClass !== null)
      ? WeightClassPayload.fromPartial(object.weightClass)
      : undefined;
    return message;
  },
};

function createBaseEntryGetWeightClassCandidateRequestPayload(): EntryGetWeightClassCandidateRequestPayload {
  return { playerId: "" };
}

export const EntryGetWeightClassCandidateRequestPayload: MessageFns<EntryGetWeightClassCandidateRequestPayload> = {
  encode(message: EntryGetWeightClassCandidateRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.playerId !== "") {
      writer.uint32(10).string(message.playerId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetWeightClassCandidateRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetWeightClassCandidateRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.playerId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetWeightClassCandidateRequestPayload {
    return { playerId: isSet(object.playerId) ? globalThis.String(object.playerId) : "" };
  },

  toJSON(message: EntryGetWeightClassCandidateRequestPayload): unknown {
    const obj: any = {};
    if (message.playerId !== "") {
      obj.playerId = message.playerId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetWeightClassCandidateRequestPayload>, I>>(
    base?: I,
  ): EntryGetWeightClassCandidateRequestPayload {
    return EntryGetWeightClassCandidateRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetWeightClassCandidateRequestPayload>, I>>(
    object: I,
  ): EntryGetWeightClassCandidateRequestPayload {
    const message = createBaseEntryGetWeightClassCandidateRequestPayload();
    message.playerId = object.playerId ?? "";
    return message;
  },
};

function createBaseEntryGetWeightClassCandidateResponsePayload(): EntryGetWeightClassCandidateResponsePayload {
  return { result: undefined, candidate: [], allOfSport: [] };
}

export const EntryGetWeightClassCandidateResponsePayload: MessageFns<EntryGetWeightClassCandidateResponsePayload> = {
  encode(
    message: EntryGetWeightClassCandidateResponsePayload,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.candidate) {
      WeightClassPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.allOfSport) {
      WeightClassPayload.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryGetWeightClassCandidateResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryGetWeightClassCandidateResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate.push(WeightClassPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.allOfSport.push(WeightClassPayload.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryGetWeightClassCandidateResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      candidate: globalThis.Array.isArray(object?.candidate)
        ? object.candidate.map((e: any) => WeightClassPayload.fromJSON(e))
        : [],
      allOfSport: globalThis.Array.isArray(object?.allOfSport)
        ? object.allOfSport.map((e: any) => WeightClassPayload.fromJSON(e))
        : [],
    };
  },

  toJSON(message: EntryGetWeightClassCandidateResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.candidate?.length) {
      obj.candidate = message.candidate.map((e) => WeightClassPayload.toJSON(e));
    }
    if (message.allOfSport?.length) {
      obj.allOfSport = message.allOfSport.map((e) => WeightClassPayload.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryGetWeightClassCandidateResponsePayload>, I>>(
    base?: I,
  ): EntryGetWeightClassCandidateResponsePayload {
    return EntryGetWeightClassCandidateResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryGetWeightClassCandidateResponsePayload>, I>>(
    object: I,
  ): EntryGetWeightClassCandidateResponsePayload {
    const message = createBaseEntryGetWeightClassCandidateResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.candidate = object.candidate?.map((e) => WeightClassPayload.fromPartial(e)) || [];
    message.allOfSport = object.allOfSport?.map((e) => WeightClassPayload.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEntryUpdatePlayerStatusRequestPayload(): EntryUpdatePlayerStatusRequestPayload {
  return { playerId: "", status: 0, rejectedReason: "" };
}

export const EntryUpdatePlayerStatusRequestPayload: MessageFns<EntryUpdatePlayerStatusRequestPayload> = {
  encode(message: EntryUpdatePlayerStatusRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.playerId !== "") {
      writer.uint32(10).string(message.playerId);
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    if (message.rejectedReason !== "") {
      writer.uint32(26).string(message.rejectedReason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryUpdatePlayerStatusRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryUpdatePlayerStatusRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.playerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rejectedReason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryUpdatePlayerStatusRequestPayload {
    return {
      playerId: isSet(object.playerId) ? globalThis.String(object.playerId) : "",
      status: isSet(object.status) ? entryPlayerStatusPayloadFromJSON(object.status) : 0,
      rejectedReason: isSet(object.rejectedReason) ? globalThis.String(object.rejectedReason) : "",
    };
  },

  toJSON(message: EntryUpdatePlayerStatusRequestPayload): unknown {
    const obj: any = {};
    if (message.playerId !== "") {
      obj.playerId = message.playerId;
    }
    if (message.status !== 0) {
      obj.status = entryPlayerStatusPayloadToJSON(message.status);
    }
    if (message.rejectedReason !== "") {
      obj.rejectedReason = message.rejectedReason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryUpdatePlayerStatusRequestPayload>, I>>(
    base?: I,
  ): EntryUpdatePlayerStatusRequestPayload {
    return EntryUpdatePlayerStatusRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryUpdatePlayerStatusRequestPayload>, I>>(
    object: I,
  ): EntryUpdatePlayerStatusRequestPayload {
    const message = createBaseEntryUpdatePlayerStatusRequestPayload();
    message.playerId = object.playerId ?? "";
    message.status = object.status ?? 0;
    message.rejectedReason = object.rejectedReason ?? "";
    return message;
  },
};

function createBaseEntryResetPasswordRequestPayload(): EntryResetPasswordRequestPayload {
  return { id: "" };
}

export const EntryResetPasswordRequestPayload: MessageFns<EntryResetPasswordRequestPayload> = {
  encode(message: EntryResetPasswordRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryResetPasswordRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryResetPasswordRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryResetPasswordRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: EntryResetPasswordRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryResetPasswordRequestPayload>, I>>(
    base?: I,
  ): EntryResetPasswordRequestPayload {
    return EntryResetPasswordRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryResetPasswordRequestPayload>, I>>(
    object: I,
  ): EntryResetPasswordRequestPayload {
    const message = createBaseEntryResetPasswordRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseEntryResetPasswordResponsePayload(): EntryResetPasswordResponsePayload {
  return { result: undefined, temporaryPassword: "" };
}

export const EntryResetPasswordResponsePayload: MessageFns<EntryResetPasswordResponsePayload> = {
  encode(message: EntryResetPasswordResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.temporaryPassword !== "") {
      writer.uint32(18).string(message.temporaryPassword);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EntryResetPasswordResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEntryResetPasswordResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.temporaryPassword = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EntryResetPasswordResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      temporaryPassword: isSet(object.temporaryPassword) ? globalThis.String(object.temporaryPassword) : "",
    };
  },

  toJSON(message: EntryResetPasswordResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.temporaryPassword !== "") {
      obj.temporaryPassword = message.temporaryPassword;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EntryResetPasswordResponsePayload>, I>>(
    base?: I,
  ): EntryResetPasswordResponsePayload {
    return EntryResetPasswordResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EntryResetPasswordResponsePayload>, I>>(
    object: I,
  ): EntryResetPasswordResponsePayload {
    const message = createBaseEntryResetPasswordResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.temporaryPassword = object.temporaryPassword ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
